import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export const timezoneDate = (timezoneSetup = 'Asia/Ho_Chi_Minh') => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.tz.setDefault(timezoneSetup);
  let date = dayjs().tz().format('YYYY/MM/DD/HH/mm/ss');
  const split = date.split('/').map((elem) => Number(elem));
  new Date();
  return new Date(
    split[0],
    split[1] - 1,
    split[2],
    split[3],
    split[4],
    split[5]
  );
};
